import { ItemTax, OrderItem } from "../../objects/orders/orderItem";
import { TaxType } from "../../objects/orders/taxType";
import { Tax } from "../../objects/orders/tax";
import { Order } from "../../objects/orders/order";

export class TaxHelper {

    public static getItemTax(orderItem: OrderItem, taxType: TaxType): ItemTax {
        const tax = this.getItemTaxOrNull(orderItem, taxType);

        return tax ? tax : new ItemTax();
    }

    public static getItemTaxOrNull(orderItem: OrderItem, taxType: TaxType): ItemTax {
       return orderItem.Taxes.find(tax => tax.TaxType == taxType);
    }


    public static convertTotalToTaxes(value: number, order: Order): Order {
        let part = 0;

        if (value > 0)
            part = +value / order.OrderItems.length;

        let total = 0;

        for (let orderItem of order.OrderItems) {
            const tax = orderItem.Taxes.find(x => x.TaxType == TaxType.AAFee);

            if (tax != null) {
                tax.Value = part.roundToDigits(2);
                total += tax.Value;
            }
        }

        this.roundLastOrderItem(order, value, total);

        return order;
    }

    public static roundLastOrderItem(order: Order, aaTotal: number, newTotal: number): void {
        if (newTotal != aaTotal) {
            const delta = ((+aaTotal).roundToDigits(5) - newTotal.roundToDigits(5)).roundToDigits(3);

            const lastOrderItem = order.OrderItems[order.OrderItems.length - 1];

            const aaFee = TaxHelper.getItemTax(lastOrderItem, TaxType.AAFee);

            if (aaFee) {
                aaFee.Value = (aaFee.Value + delta).roundToDigits(2);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/common/helpers/tax.helper.ts